import React, { FC } from "react";
import {
  GuardianFormField,
  GuardianFormFieldType,
} from "../../../../models/api-models/guardians/guardian-form";
import { FormFieldDescription } from "./FormFieldDescription";
import { FieldSignaturePreview } from "./FieldSignaturePreview";
import { FieldContainer } from "../FieldContainer";
import { GuardianSignature } from "../../Signature";
import { AthleticFormGuardianSignatureRequirement, AthleticFormSubmissionFileDto } from "../../../../models/api-models/guardians/guardian-form-submission";
import { FileLink } from "./FileLink";
import { useGuardianContext } from "../../../../context/GuardianContext";

interface FormFieldProps {
  field: GuardianFormField;
  value?: string | number;
  files?: AthleticFormSubmissionFileDto[];
  isCurrentGuardianSinged: boolean;
  isOtherGuardiansSigned: boolean; 
  currentGuardianIsActive: boolean;
}

export const FormField: FC<FormFieldProps> = ({
  field,
  value,
  files,
  isCurrentGuardianSinged,
  isOtherGuardiansSigned, 
  currentGuardianIsActive
}) => {
  const { formSubmission } = useGuardianContext();
  const signatureRequirement = formSubmission.guardianSignatureRequirement
  const isSignature = field.valueType === GuardianFormFieldType.Signature;
  const isGuardianSignature =
    field.valueType === GuardianFormFieldType.GuardianSignature;
  const isFile =
    field.valueType === GuardianFormFieldType.File && typeof value === "string";

  const isOneGuardianRequirement = 
    signatureRequirement === AthleticFormGuardianSignatureRequirement.OneGuardian;
  const isAllGuardiansRequirement = 
      signatureRequirement === AthleticFormGuardianSignatureRequirement.AllGuardians;

  const signatureFieldRender = 
      !isCurrentGuardianSinged && (
          (isOneGuardianRequirement && !isOtherGuardiansSigned) || 
          isAllGuardiansRequirement
      );

  const renderFieldsCondition = signatureFieldRender || !isGuardianSignature

  return (
    <>
      {renderFieldsCondition && (
        <FieldContainer>
          <div className="w-100 d-inline-flex align-items-center justify-content-between">
            <p className="field-name-label">{field.name}</p>
            {isGuardianSignature && (
              <span style={{ fontSize: "12px", color: "#BB4430" }}>
                Required*
              </span>
            )}
          </div>
          {field.description && (
            <FormFieldDescription
              valueType={field.valueType}
              description={field.description}
            />
          )}
          {value && !isFile && !isSignature && (
            <p className="field-name-value">{value}</p>
          )}
          {value && isSignature && (
            <FieldSignaturePreview id={value as string} />
          )}
          {isGuardianSignature && (
            <GuardianSignature
              isCurrentGuardianSinged={isCurrentGuardianSinged}
            />
          )}
          {isFile && <FileLink value={value as string} files={files} />}
        </FieldContainer>
      )}
    </>
  );
};
